<template>
  <b-row>
    <b-col cols="12">
      <b-row class="justify-content-between mb-3">
        <b-col cols="3" sm="6" md="3" class="d-flex align-items-end">
          <div>
            <label for="input">Rechercher</label>
            <b-input-group>
              <template #append>
                <b-input-group-text
                  v-if="!hasSearchInputBeenReseted || isSearchInputFocused || searchParams"
                  type="button"
                  @click="resetSearch"
                >
                  <font-awesome-icon icon="times" size="sm"></font-awesome-icon>
                </b-input-group-text>
              </template>

              <b-form-input
                id="input"
                v-model="searchParams"
                placeholder="Tapez pour rechercher"
                @focus="focusSearch"
                @blur="unfocusSearch"
                @keyup.enter="search"
              />
            </b-input-group>
            <small class="text-secondary ml-2"
              >Utilisez la touche Entrée pour lancer la recherche</small
            >
          </div>
        </b-col>
        <b-col cols="3" sm="6" md="3">
          <label>par page</label>
          <b-select
            v-model="pagination.pageSize"
            :options="[10, 20, 50, 100]"
            @input="getMajorities"
          ></b-select>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-table
        class="agv-table td-middle"
        bordered
        :items="majorities"
        :fields="fields"
        :busy="isBusy"
        show-empty
      >
        <template #head(name)>
          <div class="d-flex align-items-center">
            <span class="mr-2" @click="setSort('name')">Nom</span>
            <font-awesome-icon
              v-if="tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'desc'"
              icon="sort-up"
              @click="setSort('name', 'asc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else-if="
                tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'asc'
              "
              icon="sort-down"
              @click="setSort('name', 'desc')"
            ></font-awesome-icon>
            <font-awesome-icon v-else icon="sort" @click="setSort('name')"></font-awesome-icon>
          </div>
        </template>
        <template v-slot:cell(name)="row">
          <div class="text-left">
            <appTextArea
              :ref="'name-' + row.item.id"
              :text="row.item.name"
              :property="'name'"
              :item-id="row.item.id"
              class="min-w-130"
              @update="updateProperty"
            ></appTextArea>
          </div>
        </template>
        <template v-slot:cell(info)="row">
          <div class="text-left">
            <appMajoritiesInfo :majority="row.item"></appMajoritiesInfo>
          </div>
        </template>
        <template v-slot:cell(building)="row">
          <b-row v-if="row.item.building" class="min-w-200 text-left">
            <b-col>
              {{ row.item.building.name }}
            </b-col>
          </b-row>
        </template>
        <template v-slot:cell(_actions)="row">
          <div class="d-flex justify-content-center">
            <b-button
              class="tablebutton btn-edit"
              variant="white"
              title="Modifier la majorité"
              @click="editMajority(row.item)"
            >
              <font-awesome-icon icon="pen" size="2x" />
            </b-button>
            <b-button
              class="tablebutton btn-red"
              variant="white"
              title="Supprimer la majorité"
              @click="deleteMajority(row.item)"
            >
              <font-awesome-icon icon="trash-alt" size="2x" />
            </b-button>
          </div>
        </template>
        <template #table-busy>
          <appIsLoading />
        </template>
        <template #empty>
          <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="text-center">
      <b-col cols="4" class="m-auto d-flex justify-content-center">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.rowCount"
          :per-page="pagination.pageSize"
          aria-controls="mt-table"
          @input="getMajorities"
        ></b-pagination>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
import MajorityMW from "@/middlewares/Majority";
import MajorityORM from "@/store/orm-axios/models/Majority";
export default {
  components: {
    appMajoritiesInfo: () => import("@/components/catalogs/majorities/MajoritiesInfo"),
    appTextArea: () => import("@/components/b-table-components/TextArea"),
    appIsLoading: () => import("@/components/snippets/IsLoading"),
  },
  data() {
    return {
      tableData: [],
      fields: [
        {
          key: "name",
          label: "Nom",
        },
        {
          key: "info",
          label: "Info",
        },
        {
          key: "building",
          label: "Immeuble",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        rowCount: 0,
        pageCount: 0,
      },
      tableHeaderSettings: {
        filter: [
          {
            column: "name",
            value: "",
          },
        ],
        sort: {
          by: "created",
          dir: "desc",
        },
      },
      isBusy: true,
      searchParams: "",
      isSearchInputFocused: false,
      hasSearchInputBeenReseted: true,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    majorities() {
      return MajorityORM.query()
        .where("agency_id", this.agencyId)
        .limit(this.pagination.pageSize)
        .orderBy("created", "desc")
        .get();
    },
  },
  async created() {
    let queryParams = this.prepareQueryParams();
    await MajorityMW.QUERY_FETCH(this.agencyId, queryParams)
      .then(res => {
        let totalItems = res.response.data["hydra:totalItems"];
        this.pagination.rowCount = totalItems;
        this.tableData = res.response.data["hydra:member"];
        this.isBusy = false;
      })
      .catch(err => {
        this.isBusy = false;
      });
  },
  beforeDestroy() {
    MajorityORM.deleteAll();
  },
  methods: {
    async getMajorities() {
      this.isBusy = true;
      var queryParams = this.prepareQueryParams();
      await MajorityMW.FETCH_BY_PAGE(this.agencyId, queryParams, this.pagination)
        .then(res => {
          let totalItems = res.response.data["hydra:totalItems"];
          this.pagination.rowCount = totalItems;
          this.tableData = res.response.data["hydra:member"];
          this.isBusy = false;
        })
        .catch(err => {
          this.isBusy = false;
          // console.log("err: ", err);
        });
    },
    async updateProperty($ev) {
      // console.log("updateName: ", $ev);
      let majority = MajorityORM.query().where("id", $ev.itemId).first();
      majority[$ev.property] = $ev.value;
      await MajorityMW.PUT(majority)
        .then(() => {})
        .catch(err => {
          // console.error("err", err);
        });
    },
    prepareQueryParams() {
      var queryParams = {
        filter: [],
        sort: {},
      };
      if (this.tableHeaderSettings.sort.by && this.tableHeaderSettings.sort.dir) {
        queryParams.sort["by"] = this.tableHeaderSettings.sort.by;
        queryParams.sort["dir"] = this.tableHeaderSettings.sort.dir;
      }
      this.tableHeaderSettings.filter.forEach(filter => {
        if (!!filter.value || filter.value === 0) {
          var preparedFilter = {
            column: filter.column,
            value: filter.value,
          };
          queryParams.filter.push(preparedFilter);
        }
      });
      return queryParams;
    },
    setSort(by, dir) {
      if (!dir) {
        if (this.tableHeaderSettings.sort.dir == "asc") {
          dir = "desc";
        } else {
          dir = "asc";
        }
      }
      this.tableHeaderSettings.sort.by = by;
      this.tableHeaderSettings.sort.dir = dir;
      this.getMajorities();
    },
    editMajority(majority) {
      this.isBusy = true;
      this.$router.push({ name: "edit-majority", params: { id: majority.id } });
    },
    deleteMajority(majority) {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            MajorityMW.DELETE(majority)
              .then(() => {})
              .catch(err => {
                // console.log("error", err);
                self.$swal(self.alertError());
              });
          } else {
            // console.log("Cancel");
          }
        })
        .catch(err => {
          // console.log("error", err);
          self.$swal(self.alertError());
        });
    },
    search() {
      if (this.isBusy) return;

      this.hasSearchInputBeenReseted = false;

      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getMajorities();
    },
    focusSearch() {
      this.isSearchInputFocused = true;
    },
    unfocusSearch() {
      this.isSearchInputFocused = false;
    },
    resetSearch() {
      this.hasSearchInputBeenReseted = true;
      this.isSearchInputFocused = false;

      this.searchParams = "";
      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getMajorities();
    },
  },
};
</script>
